import {
  CaretRightOutlined,
  RightOutlined,
  CheckCircleTwoTone,
  PrinterOutlined,
  EyeOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import {
  Collapse,
  Row,
  Col,
  Button,
  Form,
  Input,
  Select,
  DatePicker,
  Alert,
  notification,
  Typography,
  Space,
  Spin,
  Card,
  Avatar,
  Descriptions,
  Modal,
  Radio,
} from "antd";
import React, { useEffect } from "react";
import { useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";

import memberService from "../../../api/member.service";
import ProgrammeCommercialService from "../../../api/programme.commercial.service";
import ProgrammeService from "../../../api/programme.service";
import timeSlotService from "../../../api/time.slot.service";

import {
  DATE_FORMAT_DMY_SLASH,
  SAVE_SUCCESS_MSG,
  SUCCESS_STATUS,
  ROUND_OFF_ACCOUNT_ID,
  MEMBER_ACCOUNT_ID,
  UPDATE_SUCCESS_MSG,
  BANK_CHARGES_ACCOUNT_ID,
  HIGH_PERFORMANCE_TAG,
  JCP_PROGRAM_TAG,
  PAYMENT_SECTION_REQUIRED_MESSAGE,
  ADD_ONE_PAYMENT_MODE,
  EDIT_MODE,
  TIME_SLOT_REQUIRED,
} from "../../../utility/Constants";

import TimeSlotEnrollment from "../TimeSlotEnrollment";
import moment from "moment";
import enrollmentService from "../../../api/enrollment.service";
import commonUtility from "../../../utility/Utils";
import EnrollmentComponent from "../commercial-components/EnrollmentComponent";
import accountService from "../../../api/account.service";
import OtherItems from "../commercial-components/OtherItems";
import TestFormItem from "../commercial-components/TestFormItem";
import PaymentComponent from "../commercial-components/PaymentComponent";
import paymentService from "../../../api/payment.service";
import StudentCardInfo from "../../common/StudentCardInfo";
import { useSelector } from "react-redux";
import ModalWithMessageAndAction from "../../common/ModalWithMessageAndAction";
import { PRINT_BASE_URL } from "../../../utility/URL";
const { Panel } = Collapse;
const { Option } = Select;
const { TextArea } = Input;
const { Text } = Typography;

const defaultFormValues = {
  mode: "ADD",
  enrollment_id: 0,
  old_enrollment_id: 0,
  enrolled_from: "FRESH",
  member_id: 0,
  programme_id: 0,
  group_id: "",
  voucher_id: 0,
  date_of_join: null,
  enrollment_start_date: null,
  enrollment_end_date: null,
  last_paid_month: "",
  dr_ac_id: "",
  student_account_id: MEMBER_ACCOUNT_ID,
  member_opening_balance: 0,
  receipt_id: 0,
  receipt_no: "",
  receipt_date: null,
  is_payment_done: "N",
  no_of_months: 0,
  entry_from: "A",
  is_gst_bill: "Y",
  round_off_amount: 0,
  round_off_account_id: ROUND_OFF_ACCOUNT_ID,
  total_bank_charges: 0,
  bank_charges_account_id: BANK_CHARGES_ACCOUNT_ID,
  day_slot: [],
  component_details_admission: [],
  component_details_monthly: [],
  component_details_others: [],
};

const HpEnrollmentEntry = () => {
  const [form] = Form.useForm();

  const params = useParams();
  let navigate = useNavigate();
  const state = useSelector((state) => state.otheritem);

  const [enrollmentID, setEnrollmentID] = useState(0);
  const [receiptID, setReceiptID] = useState(0);
  const [paymentID, setPaymentID] = useState(0);

  const [programmeGroupList, setProgrammeGroupList] = useState([]);
  const [memberList, setMemberList] = useState([]);
  const [isAlreadyMemberEnrolled, setIsAlreadyMemberEnrolled] = useState(false);
  const [alreadyMemberEnrolledMessage, setAlreadyMemberEnrolledMessage] =
    useState("");

  const [isAdmissionLoaded, setIsAdmissionLoaded] = useState([false]);
  const [progCommercialCompAdmissionList, setProgCommercialCompAdmissionList] =
    useState([]);
  const [progCommercialCompMonthlyList, setProgCommercialCompMonthlyList] =
    useState([]);
  const [progCommercialCompOtherList, setProgCommercialCompOtherList] =
    useState([]);
  const [
    progCommercialCompOtherListInitialValue,
    setProgCommercialCompOtherListInitialValue,
  ] = useState([]);

  const [programmeID, setProgrammeID] = useState([]);
  const [programmeGroupID, setProgrammeGroupID] = useState(0);

  const [monthlyComponentID, setMonthlyComponentID] = useState(0);
  const [monthlyComponentAmount, setMonthlyComponentAmount] = useState(0);
  const [monthlyComponentAccountID, setMonthlyComponentAccountID] = useState(0);
  const [monthlyComponentDesc, setMonthlyComponentDesc] = useState("");

  const [monthlyComponentCGSTID, setMonthlyComponentCGSTID] = useState(0);
  const [monthlyComponentCGSTRate, setMonthlyComponentCGSTRate] = useState(0);
  const [monthlyComponentSGSTID, setMonthlyComponentSGSTID] = useState(0);
  const [monthlyComponentSGSTRate, setMonthlyComponentSGSTRate] = useState(0);

  const [isAdmissionComponentRender, setIsAdmissionComponentRender] =
    useState(false);
  const [isMonthlyComponentRender, setIsMonthlyComponentRender] =
    useState(false);
  const [isOtherComponentRender, setIsOtherComponentRender] = useState(false);

  const [accountList, setAccountList] = useState([]);
  const [timeSlotList, setTimeSlotList] = useState([]);

  const [isFormChanged, setIsFormChanged] = useState(false);

  const [totalAmount, setTotalAmount] = useState(0);
  const [totalDiscountAmount, setTotalDiscountAmount] = useState(0);
  const [totalTaxableAmount, setTotalTaxableAmount] = useState(0);
  const [totalCGSTAmount, setTotalCGSTAmount] = useState(0);
  const [totalSGSTAmount, setTotalSGSTAmount] = useState(0);
  const [totalPayableAmount, setTotalPayableAmount] = useState(0);
  const [totalNetAmount, setTotalNetAmount] = useState(0);
  const [totalRoundOff, setTotalRoundOff] = useState(0);
  const [totalBankCharges, setTotalBankCharges] = useState(0);

  // Payment useState
  const [paymentPaidList, setPaymentPaidList] = useState([]);
  const [totalPaidAmount, setTotalPaidAmount] = useState(0);
  const [remainingAmount, setRemainingAmount] = useState(0);

  const [isSaveLoaderEnable, setSaveLoaderEnable] = useState(false);
  const [freshEnrollmentOrPromoted, setFreshEnrollmentOrPromoted] =
    useState("FRESH");

  const [programeList, setProgrameList] = useState([]);

  // member Info
  const [memberDisplayInfo, setMemberDisplayInfo] = useState({
    memberName: "",
    memberPrimaryMobile: "",
    memberFatherName: "",
    memberDOB: "",
    profilePic: "",
  });

  const [responseModal, setResponseModal] = useState({
    responseModalTitle: "",
    isOpenModal: false,
    listLink: "",
    addmoreLink: "",
    responseModalMessage: "",
    printReuired: false,
    printUrl: "",
  });

  const [memberDisplayOtherInfo, setMemberDisplayOtherInfo] = useState({
    joinDate: "",
    validity: "",
  });

  const [openModal, setOpenModal] = useState(false);
  const [responseModalTitle, setResponseModalTitle] = useState("");
  const [responseModalMessage, setResponseModalMessage] = useState("");

  const onHPenrollmentSave = async (values) => {
    // setOpenModal(false);
    // setResponseModalTitle("")
    // setResponseModalMessage("")

    setResponseModal({
      responseModalTitle: "",
      isOpenModal: false,
      listLink: "",
      addmoreLink: "",
      responseModalMessage: "",
      printReuired: false,
      printUrl: "",
    });

    // e.preventDefault()
    let isWaveReceipt;
    if (values.payable_amount == 0) {
      isWaveReceipt = "Y";
    } else {
      isWaveReceipt = "N";
    }

    // editing for others component by pritam (21-02-2025)
    // values.component_details_others = [{
    //   due_amount: 0,
    //   is_due: 'N',
    // }];

    // values.component_details_others[0] = {
    //   ...values.component_details_others[0],
    //   due_amount: 0,
    //   is_due: 'N',
    // };

    // progCommercialCompMonthlyList[0].due_amount = 0;
    // progCommercialCompMonthlyList[0].is_due = 'N';

    const data = {
      formdata: {
        ...values,
        is_wave_receipt: isWaveReceipt,
        // component_details_monthly: progCommercialCompMonthlyList
        component_details_monthly: [],
        component_details_others: [],
      },
    };
    //console.log(values);
    //return false;
    // console.log('Data: '+data)
    console.log("Data: ", data);

    if (values.day_slot.length > 0) {
      if (values.payment_data.length > 0) {
        setSaveLoaderEnable(true);

        enrollmentService
          .enrollmentHPSave(data)
          .then((res) => {
            if (isWaveReceipt === "Y") {
              notification.error({
                message: "No Reciept No. Generated",
                description:
                  "Reciept No. will not be generated against this transaction.",
                placement: "bottomRight",
                style: { color: "red" },
              });
            }
            if (
              res.data.response_data.enrolmentData &&
              res.data.response_data.enrolmentData.length > 0
            ) {
              // setOpenModal(true)
              // setResponseModalTitle("Error")
              // setResponseModalMessage("This member is already enrolled with this programme.")

              commonUtility.openNotificationWithType(
                "error",
                "bottomRight",
                "Error",
                "This member is already enrolled with this programme."
              );
            } else if (res.data.response_data.enrollment_id > 0) {
              // setOpenModal(true)
              // setResponseModalTitle("Success")
              // setResponseModalMessage(`${SAVE_SUCCESS_MSG} with Receipt Number ${res.data.response_data.receipt_no}`)

              const resp_data = res.data.response_data;
              const print_url = `${PRINT_BASE_URL}taxinvoice/receiptpdf/${
                resp_data.enrollment_id
              }/${resp_data.receipt_master_id}/${resp_data.payment_master_id}/${
                commonUtility.getLoggedInUserInfo()?.companyID > 0
                  ? commonUtility.getLoggedInUserInfo()?.companyID
                  : 0
              }`;

              setResponseModal({
                responseModalTitle: "Success",
                isOpenModal: true,
                listLink: "/high-performance/receipt-list-hp",
                addmoreLink: "/high-performance",
                responseModalMessage: `${SAVE_SUCCESS_MSG}`,
                printReuired: true,
                printUrl: print_url,
              });
            } else if (res.data.response_data.affectedRows > 0) {
              // setOpenModal(true)
              // setResponseModalTitle("Success")
              // setResponseModalMessage(`${UPDATE_SUCCESS_MSG}`)

              const resp_data = res.data.response_data;
              const print_url = `${PRINT_BASE_URL}taxinvoice/receiptpdf/${
                resp_data.enrollment_id
              }/${resp_data.receipt_master_id}/${resp_data.payment_master_id}/${
                commonUtility.getLoggedInUserInfo()?.companyID > 0
                  ? commonUtility.getLoggedInUserInfo()?.companyID
                  : 0
              }`;

              setResponseModal({
                responseModalTitle: "Success",
                isOpenModal: true,
                listLink: "/high-performance/receipt-list-hp",
                addmoreLink: "/high-performance",
                responseModalMessage: `${UPDATE_SUCCESS_MSG}`,
                printReuired: true,
                printUrl: print_url,
              });
            }
            setSaveLoaderEnable(false);
          })
          .then(() => {
            setSaveLoaderEnable(false);
          });
      } else {
        commonUtility.openNotificationWithType(
          "error",
          "bottomRight",
          "Error",
          ADD_ONE_PAYMENT_MODE
        );
      }
    } else {
      commonUtility.openNotificationWithType(
        "error",
        "bottomRight",
        "Error",
        TIME_SLOT_REQUIRED
      );
    }
  };

  const onChange = (date, dateString) => {
    // console.log(date, dateString);
  };

  const onDateOfJoinChange = (date, dateString) => {
    /*
    const dob = form.getFieldValue("date_of_birth");
    const dob_value = dob.split("/").reverse().join("-");
    const dob_obj = new Date(dob_value);
    dob_obj.setFullYear(dob_obj.getFullYear() + 18);
    let end_enrollment_date = commonUtility.dateFormatDDMMYYYY(dob_obj, "/");
    */

    form.setFieldsValue({
      date_of_join: dateString,
      //  enrollment_start_date: dateString,
      //  enrollment_end_date: end_enrollment_date,
    });

    // setMemberDisplayOtherInfo({
    //   joinDate: dateString,
    //   validity: `${dateString} to ${commonUtility.dateFormatDDMMYYYY(dob_obj, "/")}`
    // });

    createHPValidity();
  };

  const onPaymentUptoChange = (date, dateString) => {
    form.setFieldsValue({
      last_paid_month: "",
    });

    if (commonUtility.sanitizeObject(dateString) != "") {
      const dateMoment = moment(date._d);
      const month = dateMoment.month();
      const year = dateMoment.year();
      const dt = moment({ year, month }).startOf("month");
      form.setFieldsValue({
        last_paid_month: dt.format("YYYY/MM/DD"),
      });
    }
  };

  const createHPValidity = () => {
    const dob = form.getFieldValue("date_of_birth");
    const dob_value = dob.split("/").reverse().join("-");

    const dob_obj = new Date(dob_value);
    const start_date = dob_obj.setFullYear(dob_obj.getFullYear() + 6);
    let enrollment_start_date = commonUtility.dateFormatDDMMYYYY(dob_obj, "/");

    const dob_obj_end = new Date(dob_value);
    const end_date = dob_obj_end.setFullYear(dob_obj_end.getFullYear() + 100);
    let enrollment_end_date = commonUtility.dateFormatDDMMYYYY(
      dob_obj_end,
      "/"
    );

    form.setFieldsValue({
      enrollment_start_date: enrollment_start_date,
      enrollment_end_date: enrollment_end_date,
    });

    setMemberDisplayOtherInfo({
      joinDate: form.getFieldValue("date_of_join"),
      validity: `${enrollment_start_date} to ${enrollment_end_date}`,
    });
  };

  const onDateOfReceiptChange = (date, dateString) => {
    form.setFieldsValue({
      receipt_date: dateString,
    });
  };

  const onChangeCollapse = (key) => {
    // console.log(key);
  };

  const onSelectProgrammeGroup = (value, event) => {
    setProgrammeGroupID(value);
    form.setFieldsValue({ day_slot: [] });
    //admissionComponentDataByProgramme();
    onProgramAndFreshEnrollmentChange();
  };

  const onChangeMonthlyMonth = (e, v) => {
    if (commonUtility.sanitizeObject(form.getFieldValue("date_of_join"))) {
      setIsMonthlyComponentRender(false);
      const x = form.getFieldValue("no_of_months");
      const data = {
        formdata: {
          total_month: x,
          date_of_join: form.getFieldValue("date_of_join"),
        },
      };
      enrollmentService.programmeEnrollmentGenerateMonth(data).then((res) => {
        if (res.data.response_status === SUCCESS_STATUS) {
          // console.log(res.data.response_data);
          setProgCommercialCompMonthlyList(res.data.response_data);
          setIsMonthlyComponentRender(true);
        }
      });
    }
  };

  const onChangeFreshPromoted = (e) => {
    form.setFieldsValue({
      member_search: "",
      member_id: 0,
      member_name: "",
      member_primary_mobile: "",
      member_father_name: "",
      date_of_birth: null,
    });

    setMemberDisplayInfo({
      memberName: "",
      memberPrimaryMobile: "",
      memberFatherName: "",
      memberDOB: "",
      profilePic: "",
    });

    const data = {
      formdata: { programme_id: JCP_PROGRAM_TAG },
    };

    setMemberList([]);
    if (e.target.value == "FRESH") {
      memberService.allMember().then((res) => {
        if (res.data.response_status === SUCCESS_STATUS) {
          setMemberList(res.data.response_data);
        }
      });
      setFreshEnrollmentOrPromoted("FRESH");
    } else {
      ProgrammeService.memberListPromoted(data).then((res) => {
        if (res.data.response_status === SUCCESS_STATUS) {
          setMemberList(res.data.response_data);
        }
      });
      setFreshEnrollmentOrPromoted("PROMOTED");
    }
    onProgramAndFreshEnrollmentChange();
  };

  useEffect(() => {
    ProgrammeService.programmeList().then((res) => {
      if (res.data.response_status === SUCCESS_STATUS) {
        const filteredProgrammes = res.data.response_data.filter(
          (programme) =>
            programme.short_code === "HP" || programme.short_code === "JHP"
        );
        setProgrameList(filteredProgrammes);
      }
    });
  }, []);

  useEffect(() => {
    memberService.allMember().then((res) => {
      if (res.data.response_status === SUCCESS_STATUS) {
        setMemberList(res.data.response_data);
      }
    });
  }, []);

  useEffect(() => {
    const rcpt_dt = commonUtility.dateFormatDDMMYYYY(new Date(), "/");
    form.setFieldsValue({
      receipt_date: rcpt_dt,
    });
  }, []);

  useEffect(() => {
    ProgrammeService.programmeGroupList().then((res) => {
      if (res.data.response_status === SUCCESS_STATUS) {
        setProgrammeGroupList(res.data.response_data);
      }
    });
  }, []);

  // useEffect(() => {
  //   const data = {
  //     formdata: { short_code: HIGH_PERFORMANCE_TAG },
  //   };
  //   ProgrammeService.programmeByCode(data).then((res) => {
  //     if (res.data.response_status === SUCCESS_STATUS) {
  //       setProgrammeID(res.data.response_data[0].programme_id);
  //       form.setFieldsValue({
  //         programme_id: res.data.response_data[0].programme_id,
  //       });
  //     }
  //   });
  // }, []);

  useEffect(() => {
    const data = {
      formdata: {
        programme_id: form.getFieldValue("programme_id"),
        component_type: "MONTHLY",
        group_id: form.getFieldValue("group_id"),
        is_gst_applicable: "Y",
      },
    };
    ProgrammeCommercialService.programmeCommercialByOptions(data).then(
      (res) => {
        if (res.data.response_status === SUCCESS_STATUS) {
          if (res.data.response_data.length > 0) {
            setMonthlyComponentID(res.data.response_data[0].component_id);
            setMonthlyComponentAmount(res.data.response_data[0].amount);
            setMonthlyComponentDesc(res.data.response_data[0].description);
            setMonthlyComponentAccountID(res.data.response_data[0].account_id);

            setMonthlyComponentCGSTID(
              commonUtility.sanitizeValue(res.data.response_data[0].cgst_id)
            );
            setMonthlyComponentCGSTRate(
              commonUtility.sanitizeValue(res.data.response_data[0].cgst_rate)
            );
            setMonthlyComponentSGSTID(
              commonUtility.sanitizeValue(res.data.response_data[0].sgst_id)
            );
            setMonthlyComponentSGSTRate(
              commonUtility.sanitizeValue(res.data.response_data[0].sgst_rate)
            );
          }
        }
      }
    );
  }, [programmeGroupID]);

  /*
    useEffect(() => {
        setIsOtherComponentRender(false);
        const data = {
            formdata: { programme_id: programmeID, component_type: "OTHERS", group_id: programmeGroupID },
        };
        ProgrammeCommercialService.programmeCommercialByOptions(data).then(
            (res) => {
                if (res.data.response_status === SUCCESS_STATUS) {
                    setProgCommercialCompOtherList(res.data.response_data);
                    setIsOtherComponentRender(true);
                }
            }
        );
    }, []);
    */

  //   const admissionComponentDataByProgramme = () => {
  //     let freshPromoted = form.getFieldValue("enrolled_from");
  //     setProgCommercialCompAdmissionList([]);
  //     form.setFieldsValue({ component_details_admission: [] });

  //     if(freshPromoted == "FRESH") {
  //       const data = {
  //         formdata: {
  //           programme_id: programmeID,
  //           component_type: "ADMISSION",
  //           group_id: programmeGroupID,
  //           is_gst_applicable: 'Y'
  //         },
  //       };

  //       ProgrammeCommercialService.programmeCommercialByOptions(data).then(
  //         (res) => {
  //           if (res.data.response_status === SUCCESS_STATUS) {

  //             //  console.log("Admission Commercial ", res.data.response_data)
  //             setProgCommercialCompAdmissionList(res.data.response_data);
  //             setIsAdmissionComponentRender(true);

  //           }
  //         }
  //       );

  //       let obj = [];
  //       progCommercialCompAdmissionList.map((e) => {
  //         let cgst_amount = 0;
  //         let sgst_amount = 0;
  //         let total_gst_amt = 0;
  //         let payable_amount = e.amount;

  //         if (e.cgst_rate > 0 && e.sgst_rate > 0 && e.amount > 0) {
  //           cgst_amount = (parseFloat(e.amount) * parseFloat(e.cgst_rate)) / 100;
  //           sgst_amount = (parseFloat(e.amount) * parseFloat(e.sgst_rate)) / 100;
  //           total_gst_amt = cgst_amount + sgst_amount;
  //           payable_amount = e.amount + total_gst_amt;
  //         }

  //         const x = {
  //           component_id: e.component_id,
  //           description: e.description,
  //           month_id: 0,
  //           year: 0,
  //           amount: e.amount,
  //           cr_ac_id: e.account_id,
  //           discount: 0,
  //           taxable_amount: e.amount,
  //           cgst_id: e.cgst_id,
  //           cgst_rate: e.cgst_rate,
  //           cgst_rate_text: commonUtility.sanitizeObject(e.cgst_rate) != "" ? `${e.cgst_rate}%` : '0%',
  //           cgst_amount: cgst_amount,
  //           sgst_id: e.sgst_id,
  //           sgst_rate: e.sgst_rate,
  //           sgst_rate_text: commonUtility.sanitizeObject(e.sgst_rate) != "" ? `${e.sgst_rate}%` : '0%',
  //           sgst_amount: sgst_amount,
  //           total_gst_amount: total_gst_amt,
  //           net_amount: payable_amount,
  //         };
  //         obj.push(x);
  //       });

  //       console.log('obj output',obj);

  //       form.setFieldsValue({ component_details_admission: obj });
  //     }

  //     onFormCalculation();
  // }

  useEffect(() => {
    //setIsLoaded(false);
    // let enrolled_from = form.getFieldValue("enrolled_from");
    // setIsAdmissionComponentRender(false);
    // if(enrolled_from == "FRESH") {
    //   const data = {
    //     formdata: {
    //       programme_id: programmeID,
    //       component_type: "ADMISSION",
    //       group_id: programmeGroupID,
    //       is_gst_applicable: 'Y'
    //     },
    //   };
    //   ProgrammeCommercialService.programmeCommercialByOptions(data).then(
    //     (res) => {
    //       if (res.data.response_status === SUCCESS_STATUS) {
    //         setProgCommercialCompAdmissionList(res.data.response_data);
    //         setIsAdmissionComponentRender(true);
    //       }
    //     }
    //   );
    // }
    // else{
    //   setProgCommercialCompAdmissionList([])
    //   setIsAdmissionComponentRender(true);
    //   form.setFieldsValue({ component_details_admission: [] });
    //   onFormCalculation();
    // }
  }, [programmeGroupID, freshEnrollmentOrPromoted]);

  const onProgramAndFreshEnrollmentChange = () => {
    let enrolled_from = form.getFieldValue("enrolled_from");
    const member_id = form.getFieldValue("member_id");
    // console.log("programmeID",form.getFieldValue("programme_id"));
    setIsAdmissionComponentRender(false);
    if (enrolled_from == "FRESH" && member_id > 0) {
      const data = {
        formdata: {
          // programme_id: programmeID,
          programme_id: form.getFieldValue("programme_id"),
          component_type: "ADMISSION",
          //group_id: programmeGroupID,
          //group_id:form.getFieldValue("group_id"),
          is_gst_applicable: "Y",
        },
      };
      ProgrammeCommercialService.programmeCommercialByOptionsHP(data).then(
        (res) => {
          if (res.data.response_status === SUCCESS_STATUS) {
            setProgCommercialCompAdmissionList(res.data.response_data);
            setProgCommercialCompMonthlyList(res.data.response_data);
            setIsAdmissionComponentRender(true);
          }
        }
      );
    } else {
      setProgCommercialCompAdmissionList([]);
      setIsAdmissionComponentRender(true);
      form.setFieldsValue({ component_details_admission: [] });
      onFormCalculation();
    }
  };

  // Admission Component =============
  useEffect(() => {
    // console.log("progCommercialCompAdmissionList",progCommercialCompAdmissionList);
    let obj = [];
    progCommercialCompAdmissionList.map((e) => {
      let cgst_amount = 0;
      let sgst_amount = 0;
      let total_gst_amt = 0;
      let payable_amount = e.amount;

      if (e.cgst_rate > 0 && e.sgst_rate > 0 && e.amount > 0) {
        cgst_amount = (parseFloat(e.amount) * parseFloat(e.cgst_rate)) / 100;
        sgst_amount = (parseFloat(e.amount) * parseFloat(e.sgst_rate)) / 100;
        total_gst_amt = cgst_amount + sgst_amount;
        payable_amount = e.amount + total_gst_amt;
      }

      const x = {
        component_id: e.component_id,
        description: e.description,
        month_id: 0,
        year: 0,
        amount: e.amount,
        cr_ac_id: e.account_id,
        discount: 0,
        taxable_amount: e.amount,
        cgst_id: e.cgst_id,
        cgst_rate: e.cgst_rate,
        cgst_rate_text:
          commonUtility.sanitizeObject(e.cgst_rate) != ""
            ? `${e.cgst_rate}%`
            : "0%",
        cgst_amount: cgst_amount,
        sgst_id: e.sgst_id,
        sgst_rate: e.sgst_rate,
        sgst_rate_text:
          commonUtility.sanitizeObject(e.sgst_rate) != ""
            ? `${e.sgst_rate}%`
            : "0%",
        sgst_amount: sgst_amount,
        total_gst_amount: total_gst_amt,
        net_amount: payable_amount,
        due_amount: 0,
        is_due: "N",
      };
      obj.push(x);
    });
    form.setFieldsValue({ component_details_admission: obj });
    onFormCalculation();
  }, [isAdmissionComponentRender]);

  const onSelectProgramme = (value, event) => {
    // setProgCommercialCompAdmissionList([]);

    const selectedProgramme = programeList.find(
      (programme) => programme.programme_id === value
    );
    setProgrammeID(value);

    // console.log("form.getFieldValue",form.getFieldValue("mode"));
    // console.log("selectedProgramme",selectedProgramme);
    setMemberDisplayInfo({
      memberName: "",
      memberPrimaryMobile: "",
      memberFatherName: "",
      memberDOB: "",
      profilePic: "",
    });

    // if (selectedProgramme) {
    form.setFieldsValue({
      programme_id: value,
      member_search: "",
      member_id: 0,
      member_name: "",
      member_primary_mobile: "",
      member_father_name: "",
      date_of_birth: null,
    });
    // }
    // onProgramAndFreshEnrollmentChange();
  };

  const onSelectMember = (value, object) => {
    setIsAlreadyMemberEnrolled(false);
    setAlreadyMemberEnrolledMessage("");

    const data = { formdata: { member_id: value, programme_id: programmeID } };
// console.log("data",data)
    ProgrammeService.checkMemberEnrolement(data).then((res) => {
      if (res.data.response_status === SUCCESS_STATUS) {
        const response = res.data.response_data;

        form.setFieldsValue({
          member_id: response.memberData[0].member_id,
          member_name:
            response.memberData[0].member_fname +
            " " +
            response.memberData[0].member_lname,
          member_primary_mobile: response.memberData[0].primary_mobile,
          member_father_name: response.memberData[0].father_name,
          date_of_birth: response.memberData[0].date_of_birth,
          old_enrollment_id: object?.enrollmentid,
        });

        setMemberDisplayInfo({
          memberName: `${response.memberData[0].member_fname} ${response.memberData[0].member_lname}`,
          memberPrimaryMobile: response.memberData[0].primary_mobile,
          memberFatherName: response.memberData[0].father_name,
          memberDOB: response.memberData[0].date_of_birth,
          profilePic: response.memberData[0].profile_picture,
        });
        //console.log("Enrolment date length",response.enrolmentData.length)

        createHPValidity();

        onProgramAndFreshEnrollmentChange();

        if (response.enrolmentData.length > 0) {
          setIsAlreadyMemberEnrolled(true);
          setAlreadyMemberEnrolledMessage(
            "You already have an active package against this programme."
          );
        }
      }
    });
  };

  // Monthly Component ======
  useEffect(() => {
    let obj = [];

    let cgst_amount = 0;
    let sgst_amount = 0;
    let total_gst_amt = 0;
    let payable_amount = monthlyComponentAmount;

    if (
      monthlyComponentCGSTRate > 0 &&
      monthlyComponentSGSTRate > 0 &&
      monthlyComponentAmount > 0
    ) {
      cgst_amount =
        (parseFloat(monthlyComponentAmount) *
          parseFloat(monthlyComponentCGSTRate)) /
        100;
      sgst_amount =
        (parseFloat(monthlyComponentAmount) *
          parseFloat(monthlyComponentSGSTRate)) /
        100;
      total_gst_amt = cgst_amount + sgst_amount;
      payable_amount = monthlyComponentAmount + total_gst_amt;
    }

    progCommercialCompMonthlyList.map((e) => {
      const x = {
        component_id: monthlyComponentID,
        description: e.month_year,
        month_id: e.month_id,
        year: e.year,
        amount: monthlyComponentAmount,
        cr_ac_id: monthlyComponentAccountID,
        discount: 0,
        taxable_amount: monthlyComponentAmount,
        cgst_id: monthlyComponentCGSTID,
        cgst_rate: monthlyComponentCGSTRate,
        cgst_rate_text: `${monthlyComponentCGSTRate}%`,
        cgst_amount: cgst_amount,
        sgst_id: monthlyComponentSGSTID,
        sgst_rate: monthlyComponentSGSTRate,
        sgst_amount: sgst_amount,
        sgst_rate_text: `${monthlyComponentSGSTRate}%`,
        total_gst_amount: total_gst_amt,
        net_amount: payable_amount,
        is_waiver: e.is_waiver,
        //  due_amount: 0,
        // is_due: 'N'
      };
      obj.push(x);
    });

    form.setFieldsValue({ component_details_monthly: obj });
    onFormCalculation();
  }, [isMonthlyComponentRender]);

  /*
    useEffect(() => {
        let obj = [];
        progCommercialCompOtherList.map((e) => {
            const x = {
                component_id: e.component_id,
                description: e.description,
                month_id: 0,
                year: 0,
                amount: e.amount,
                cr_ac_id: e.account_id,
                discount: 0,
                taxable_amount: e.amount,
                cgst_id: 0,
                cgst_amount: "",
                sgst_id: 0,
                sgst_amount: "",
                total_gst_amount: 0,
                net_amount: 0,
            };
            obj.push(x);
        });

        form.setFieldsValue({ component_details_others: obj });
    }, [isOtherComponentRender]);
    */

  useEffect(() => {
    accountService.accountList().then((res) => {
      setAccountList(res.data.response_data);
    });
  }, []);

  useEffect(() => {
    const data = {
      formdata: {
        programme_id: programmeID,
        programme_group_id: programmeGroupID,
      },
    };
    timeSlotService.timeSlotByProgrammeAndGroup(data).then((res) => {
      if (res.data.response_status === SUCCESS_STATUS) {
        setTimeSlotList(res.data.response_data);
      }
    });
  }, [programmeGroupID, enrollmentID]);

  const onFormCalculation = () => {
    setIsFormChanged(false);

    let resultCGST = [];
    let resultSGST = [];

    // Admission
    let admission_total_amount = form
      .getFieldValue("component_details_admission")
      .reduce((total, obj) => parseFloat(obj.amount) + total, 0);
    let admission_total_discount = form
      .getFieldValue("component_details_admission")
      .reduce((total, obj) => parseFloat(obj.discount) + total, 0);
    let admission_total_taxable = form
      .getFieldValue("component_details_admission")
      .reduce((total, obj) => parseFloat(obj.taxable_amount) + total, 0);
    let admission_total_cgst_amount = form
      .getFieldValue("component_details_admission")
      .reduce((total, obj) => parseFloat(obj.cgst_amount) + total, 0);
    let admission_total_sgst_amount = form
      .getFieldValue("component_details_admission")
      .reduce((total, obj) => parseFloat(obj.sgst_amount) + total, 0);

    form
      .getFieldValue("component_details_admission")
      .reduce(function (res, value) {
        if (!res[value.cgst_id]) {
          res[value.cgst_id] = {
            gst_id: value.cgst_id,
            amount: 0,
            cgst_rate: value.cgst_rate,
          };
          resultCGST.push(res[value.cgst_id]);
        }
        res[value.cgst_id].amount += value.cgst_amount;
        return res;
      }, {});

    form
      .getFieldValue("component_details_admission")
      .reduce(function (res, value) {
        if (!res[value.sgst_id]) {
          res[value.sgst_id] = {
            gst_id: value.sgst_id,
            amount: 0,
            sgst_rate: value.sgst_rate,
          };
          resultSGST.push(res[value.sgst_id]);
        }
        res[value.sgst_id].amount += value.sgst_amount;
        return res;
      }, {});

    // Monthly
    let monthly_total_amount = form
      .getFieldValue("component_details_monthly")
      .reduce((total, obj) => parseFloat(obj.amount) + total, 0);
    let monthly_total_discount = form
      .getFieldValue("component_details_monthly")
      .reduce((total, obj) => parseFloat(obj.discount) + total, 0);
    let monthly_total_taxable = form
      .getFieldValue("component_details_monthly")
      .reduce((total, obj) => parseFloat(obj.taxable_amount) + total, 0);
    let monthly_total_cgst_amount = form
      .getFieldValue("component_details_monthly")
      .reduce((total, obj) => parseFloat(obj.cgst_amount) + total, 0);
    let monthly_total_sgst_amount = form
      .getFieldValue("component_details_monthly")
      .reduce((total, obj) => parseFloat(obj.sgst_amount) + total, 0);

    //let resultCGST_Monthly = [];
    form
      .getFieldValue("component_details_monthly")
      .reduce(function (res, value) {
        if (!res[value.cgst_id]) {
          res[value.cgst_id] = {
            gst_id: value.cgst_id,
            amount: value.cgst_amount,
            cgst_rate: value.cgst_rate,
          };
          //resultCGST_Monthly.push(res[value.cgst_id])
          resultCGST.push(res[value.cgst_id]);
        }
        res[value.cgst_id].amount += value.cgst_amount;
        return res;
      }, {});

    //let resultSGST_Monthly = [];
    form
      .getFieldValue("component_details_monthly")
      .reduce(function (res, value) {
        if (!res[value.sgst_id]) {
          res[value.sgst_id] = {
            gst_id: value.sgst_id,
            amount: value.sgst_amount,
            sgst_rate: value.sgst_rate,
          };
          resultSGST.push(res[value.sgst_id]);
        }
        res[value.sgst_id].amount += value.sgst_amount;
        return res;
      }, {});

    // Others
    let others_total_amount = form
      .getFieldValue("component_details_others")
      .reduce((total, obj) => parseFloat(obj.amount) + total, 0);
    let others_total_discount = form
      .getFieldValue("component_details_others")
      .reduce((total, obj) => parseFloat(obj.discount) + total, 0);
    let others_total_taxable = form
      .getFieldValue("component_details_others")
      .reduce((total, obj) => parseFloat(obj.taxable_amount) + total, 0);
    let others_total_cgst_amount = form
      .getFieldValue("component_details_others")
      .reduce((total, obj) => parseFloat(obj.cgst_amount) + total, 0);
    let others_total_sgst_amount = form
      .getFieldValue("component_details_others")
      .reduce((total, obj) => parseFloat(obj.sgst_amount) + total, 0);

    //let resultCGST_Others = [];
    form
      .getFieldValue("component_details_others")
      .reduce(function (res, value) {
        if (!res[value.cgst_id]) {
          res[value.cgst_id] = {
            gst_id: value.cgst_id,
            amount: value.cgst_amount,
            cgst_rate: value.cgst_rate,
          };
          resultCGST.push(res[value.cgst_id]);
        }
        res[value.cgst_id].amount += value.cgst_amount;
        return res;
      }, {});

    //let resultSGST_Others = [];
    form
      .getFieldValue("component_details_others")
      .reduce(function (res, value) {
        if (!res[value.sgst_id]) {
          res[value.sgst_id] = {
            gst_id: value.sgst_id,
            amount: value.sgst_amount,
            sgst_rate: value.sgst_rate,
          };
          resultSGST.push(res[value.sgst_id]);
        }
        res[value.sgst_id].amount += value.sgst_amount;
        return res;
      }, {});

    let total_amount =
      parseFloat(commonUtility.sanitizeValue(admission_total_amount)) +
      parseFloat(commonUtility.sanitizeValue(monthly_total_amount)) +
      parseFloat(commonUtility.sanitizeValue(others_total_amount));
    let total_discount =
      parseFloat(commonUtility.sanitizeValue(admission_total_discount)) +
      parseFloat(commonUtility.sanitizeValue(monthly_total_discount)) +
      parseFloat(commonUtility.sanitizeValue(others_total_discount));
    let total_taxable =
      parseFloat(commonUtility.sanitizeValue(admission_total_taxable)) +
      parseFloat(commonUtility.sanitizeValue(monthly_total_taxable)) +
      parseFloat(commonUtility.sanitizeValue(others_total_taxable));
    let total_cgst_amount =
      parseFloat(commonUtility.sanitizeValue(admission_total_cgst_amount)) +
      parseFloat(commonUtility.sanitizeValue(monthly_total_cgst_amount)) +
      parseFloat(commonUtility.sanitizeValue(others_total_cgst_amount));
    let total_sgst_amount =
      parseFloat(commonUtility.sanitizeValue(admission_total_sgst_amount)) +
      parseFloat(commonUtility.sanitizeValue(monthly_total_sgst_amount)) +
      parseFloat(commonUtility.sanitizeValue(others_total_sgst_amount));
    let total_payable_amount =
      parseFloat(commonUtility.sanitizeValue(total_taxable)) +
      parseFloat(commonUtility.sanitizeValue(total_cgst_amount)) +
      parseFloat(commonUtility.sanitizeValue(total_sgst_amount));

    // form.setFieldsValue({
    //   payable_amount: total_payable_amount.toFixed(2)
    // });

    //const total_bank_charges = commonUtility.sanitizeValue(form.getFieldValue("total_bank_charges"));
    //const total_bank_charges = commonUtility.sanitizeValue(form.getFieldValue("total_bank_charges"));

    const payableAmountDetail =
      commonUtility.getRoundOfAmount(total_payable_amount);
    const new_payable_amount = payableAmountDetail.newPayableAmount;
    const roundoff_amount = payableAmountDetail.roundoffAmount;

    // console.log("new_payable_amount",new_payable_amount);

    form.setFieldsValue({
      payable_amount: new_payable_amount,
      round_off_amount: roundoff_amount,
    });

    setTotalAmount(total_amount.toFixed(2));
    setTotalDiscountAmount(total_discount.toFixed(2));
    setTotalTaxableAmount(total_taxable.toFixed(2));
    setTotalCGSTAmount(total_cgst_amount.toFixed(2));
    setTotalSGSTAmount(total_sgst_amount.toFixed(2));
    setTotalNetAmount(total_payable_amount.toFixed(2));
    // setTotalPayableAmount(total_payable_amount.toFixed(2))
    setTotalPayableAmount(new_payable_amount.toFixed(2));

    setTotalRoundOff(0);
    if (roundoff_amount) {
      setTotalRoundOff(`${roundoff_amount}`);
    }

    // console.log("total_amount = ",total_amount.toFixed(2))
    // console.log("total_discount = ",total_discount.toFixed(2))
    // console.log("total_taxable = ",total_taxable.toFixed(2))
    // console.log("total_cgst_amount = ",total_cgst_amount.toFixed(2))
    // console.log("total_sgst_amount = ",total_sgst_amount.toFixed(2))
    // console.log("total_payable_amount = ",total_payable_amount.toFixed(2))
    // console.log("new_payable_amount = ",new_payable_amount.toFixed(2))

    // setIsFormChanged(true)
  };

  useEffect(() => {
    onFormCalculation();
    // console.log("Form changed")
  }, [form, state.otheritem]);

  // useEffect(() => {
  //   onFormCalculation();
  //   console.log("Form changed")
  // }, [state.otheritem]);

  const [isPaymentModeDisabled, setIsPaymentModeDisabled] = useState(false);
  const addPaymentMode = () => {
    const selected_payment_mode_text = form.getFieldValue(
      "selected_payment_mode_text"
    );
    const mode = form.getFieldValue("selected_payments_mode");
    const paid_amount = form.getFieldValue("paid_amount");
    const dr_account_id = form.getFieldValue("dr_account_id");
    const cheque_no = form.getFieldValue("cheque_no");
    const cheque_date = form.getFieldValue("cheque_date");
    const bank = form.getFieldValue("bank");
    const branch = form.getFieldValue("branch");
    const bank_charges = commonUtility.sanitizeValue(
      form.getFieldValue("bank_charges")
    );
    const payment_ref = form.getFieldValue("payment_ref");

    let bank_charges_amount = 0;
    if (commonUtility.sanitizeValue(bank_charges) > 0) {
      bank_charges_amount =
        (parseFloat(paid_amount) * parseFloat(bank_charges)) / 100;
      bank_charges_amount = Math.round(bank_charges_amount);
    }

    setIsOtherComponentRender(false);

    if (
      commonUtility.sanitizeObject(selected_payment_mode_text) &&
      commonUtility.sanitizeObject(mode)
    ) {
      let amount = parseFloat(paid_amount) + parseFloat(bank_charges_amount);
      setPaymentPaidList([
        ...paymentPaidList,
        {
          rowKey: commonUtility.randomID(),
          mode_description: selected_payment_mode_text,
          payment_mode_text: selected_payment_mode_text,
          payment_mode_id: mode,
          payment_mode: mode,
          dr_account_id: dr_account_id,
          amount: amount,
          paid_amount: paid_amount,
          cheque_no: cheque_no,
          cheque_date: cheque_date,
          bank_name: bank,
          bank_branch: branch,
          bank_charges: bank_charges_amount,
          payment_ref: payment_ref,
        },
      ]);

      setIsPaymentModeDisabled(true);

      form.setFieldsValue({
        selected_payment_mode_text: "",
        selected_payments_mode: "",
        cheque_no: "",
        cheque_date: "",
        bank: "",
        payment_ref: "",
      });
      setIsOtherComponentRender(false);
    } else {
      commonUtility.openNotificationWithType(
        "error",
        "bottomRight",
        "Error",
        PAYMENT_SECTION_REQUIRED_MESSAGE
      );
    }
  };

  const removePayment = (index) => {
    const list = [...paymentPaidList];
    list.splice(index, 1);
    setPaymentPaidList(list);
    if (list.length === 0) {
      setIsPaymentModeDisabled(false);
    }
  };

  useEffect(() => {
    // setRemainingAmount(parseFloat(totalPayableAmount) - parseFloat(totalPaidAmount))
    // console.log("totalPayableAmount",totalPayableAmount);
    // console.log("totalBankCharges",totalBankCharges);
    // console.log("totalPaidAmount",totalPaidAmount);
    setRemainingAmount(
      (parseFloat(totalPayableAmount) +
        parseFloat(totalBankCharges)) -
        parseFloat(totalPaidAmount)
    );
    
  }, [totalPayableAmount, totalPaidAmount, totalBankCharges]);

  /** ****************************************************************************
   * ******************************* Edit Mode ***********************************
   * *****************************************************************************
   */

  useEffect(() => {
    setEnrollmentID(params.enrollmentid);
    setReceiptID(params.receiptid);
    setPaymentID(params.paymentid);
  }, []);

  useEffect(() => {
    if (enrollmentID > 0 && receiptID > 0) {
      // Setting Up Personal Info
      const data = {
        formdata: {
          enrollment_id: enrollmentID,
        },
      };

      enrollmentService.JCPenrollmentDatabyID(data).then((res) => {
        if (res.data.response_status === SUCCESS_STATUS) {
          const enrollment_data = res.data.response_data[0];

          const last_paid_date_val = enrollment_data.last_paid_month;
          let last_paid_month_val = "";
          if (commonUtility.sanitizeObject(last_paid_date_val) != "") {
            let lpary = last_paid_date_val.split("/");
            last_paid_month_val = lpary[1] + "/" + lpary[0];
          }

          form.setFieldsValue({
            mode: "EDIT",
            enrollment_id: enrollmentID,
            member_search: enrollment_data.member_id,
            enrolled_from: enrollment_data.enrolled_from,
            member_id: enrollment_data.member_id,
            member_name: `${enrollment_data.member_fname} ${enrollment_data.member_lname}`,
            member_primary_mobile: enrollment_data.primary_mobile,
            member_father_name:
              enrollment_data.father_name != null &&
              enrollment_data.father_name != ""
                ? enrollment_data.father_name
                : "",
            date_of_birth: enrollment_data.date_of_birth,
            programme_id: enrollment_data.programme_id,
            group_id: enrollment_data.group_id,
            join_date:
              enrollment_data.enrollment_date != null &&
              enrollment_data.enrollment_date != ""
                ? moment(enrollment_data.enrollment_date, DATE_FORMAT_DMY_SLASH)
                : "",
            date_of_join: enrollment_data.enrollment_date,
            last_paid_month_picker:
              commonUtility.sanitizeObject(last_paid_month_val) != ""
                ? moment(last_paid_month_val, "MM/YYYY")
                : "",
            last_paid_month: enrollment_data.last_paid_month,
            enrollment_start_date: enrollment_data.enrollment_start_date,
            enrollment_end_date: enrollment_data.enrollment_end_date,
          });

          setMemberDisplayInfo({
            memberName: `${enrollment_data.member_fname} ${enrollment_data.member_lname}`,
            memberPrimaryMobile: enrollment_data.primary_mobile,
            memberFatherName:
              enrollment_data.father_name != null &&
              enrollment_data.father_name != ""
                ? enrollment_data.father_name
                : "",
            memberDOB: enrollment_data.date_of_birth,
            profilePic: enrollment_data.profile_picture,
          });

          setMemberDisplayOtherInfo({
            joinDate: enrollment_data.enrollment_date,
            validity: `${enrollment_data.enrollment_start_date} to ${enrollment_data.enrollment_end_date}`,
          });

          setProgrammeID(enrollment_data.programme_id);
          setProgrammeGroupID(enrollment_data.group_id);
        }
      });

      setIsAdmissionComponentRender(false);
      const admdata = {
        formdata: {
          receipt_id: receiptID,
          component_type: "ADMISSION",
        },
      };

      enrollmentService.componentDetailsAgainstReceipt(admdata).then((res) => {
        if (res.data.response_status === SUCCESS_STATUS) {
          // console.log("object",res.data.response_data);
          /*
          const monthly_component_details = res.data.response_data;
          let obj = [];
          monthly_component_details.map((e) => {
            const x = {
              component_id: e.component_id,
              description: e.description,
              month_id: e.month_id,
              year: e.year,
              amount: e.amount,
              cr_ac_id: e.cr_ac_id,
              discount: e.discount,
              taxable_amount: e.taxable_amount,
              cgst_id: e.cgst_id,
              cgst_rate: e.cgst_rate,
              cgst_rate_text: `${commonUtility.sanitizeValue(e.cgst_rate)}%`,
              cgst_amount: e.cgst_amount,
              sgst_id: e.sgst_id,
              sgst_rate: e.sgst_rate,
              sgst_rate_text: `${commonUtility.sanitizeValue(e.sgst_rate)}%`,
              sgst_amount: e.sgst_amount,
              total_gst_amount: e.total_gst_amount,
              net_amount: e.net_amount,
            };
            obj.push(x);
          });

          form.setFieldsValue({ component_details_admission: obj });
          setIsAdmissionComponentRender(true)
          */
        //  console.log("res.data.response_data",res.data.response_data);

          // setProgCommercialCompAdmissionList(res.data.response_data);
          form.setFieldsValue({ component_details_admission: res.data.response_data });
          // setIsAdmissionComponentRender(true);
        }
      });

      //Monthly Component

      const monthlycomponentdata = {
        formdata: {
          receipt_id: receiptID,
          component_type: "MONTHLY",
        },
      };

      enrollmentService
        .componentDetailsAgainstReceipt(monthlycomponentdata)
        .then((res2) => {
          if (res2.data.response_status === SUCCESS_STATUS) {
            const monthly_component_details = res2.data.response_data;
            let obj = [];
            monthly_component_details.map((e) => {
              const x = {
                component_id: e.component_id,
                description: e.description,
                month_id: e.month_id,
                year: e.year,
                amount: e.amount,
                cr_ac_id: e.cr_ac_id,
                discount: e.discount,
                taxable_amount: e.taxable_amount,
                cgst_id: e.cgst_id,
                cgst_rate: e.cgst_rate,
                cgst_rate_text: `${commonUtility.sanitizeValue(e.cgst_rate)}%`,
                cgst_amount: e.cgst_amount,
                sgst_id: e.sgst_id,
                sgst_rate: e.sgst_rate,
                sgst_rate_text: `${commonUtility.sanitizeValue(e.sgst_rate)}%`,
                sgst_amount: e.sgst_amount,
                total_gst_amount: e.total_gst_amount,
                net_amount: e.net_amount,
                is_waiver: e.is_waiver,
                //  is_waiver_option:true
              };
              obj.push(x);
            });

            form.setFieldsValue({ component_details_monthly: obj });
          }
        });

      // Other Component

      const othercomponentdata = {
        formdata: {
          receipt_id: receiptID,
          component_type: "OTHERS",
        },
      };

      enrollmentService
        .componentDetailsAgainstReceipt(othercomponentdata)
        .then((res3) => {
          if (res3.data.response_status === SUCCESS_STATUS) {
            setProgCommercialCompOtherListInitialValue([]);
            const other_component_details = res3.data.response_data;
            let obj = [];
            setProgCommercialCompOtherListInitialValue(other_component_details);
          }
        });

      setTotalAmount(0);
      setTotalDiscountAmount(0);
      setTotalTaxableAmount(0);
      setTotalCGSTAmount(0);
      setTotalSGSTAmount(0);
      setTotalNetAmount(0);
      setTotalPayableAmount(0);

      const receipt_master_data = {
        formdata: {
          receipt_id: receiptID,
        },
      };
      enrollmentService.JCPReceiptDatabyID(receipt_master_data).then((res4) => {
        if (res4.data.response_status === SUCCESS_STATUS) {
          const receipt_data = res4.data.response_data[0];
         console.log("receipt_data",receipt_data);
          form.setFieldsValue({
            mode: "EDIT",
            no_of_months: receipt_data.no_of_months,
            receipt_id: receipt_data.receipt_id,
            receipt_no: receipt_data.receipt_no,
            receipt_date: receipt_data.receipt_date,
            receipt_date_input:
              receipt_data.receipt_date != null &&
              receipt_data.receipt_date != ""
                ? moment(receipt_data.receipt_date, DATE_FORMAT_DMY_SLASH)
                : "",
            dr_ac_id: receipt_data.dr_ac_id,
            entry_from: receipt_data.entry_from,
          });

          setTotalAmount(receipt_data.total_amount.toFixed(2));
          setTotalDiscountAmount(receipt_data.total_discount.toFixed(2));
          setTotalTaxableAmount(receipt_data.total_taxable_amount.toFixed(2));
          setTotalCGSTAmount(receipt_data.total_cgst_amount.toFixed(2));
          setTotalSGSTAmount(receipt_data.total_sgst_amount.toFixed(2));

          const total_net_amount =
            receipt_data.total_taxable_amount +
            receipt_data.total_cgst_amount +
            receipt_data.total_sgst_amount;
          setTotalNetAmount(total_net_amount.toFixed(2));
          // const net_payble_amount = parseFloat(receipt_data.net_payble_amount) - parseFloat(receipt_data.total_bank_charges);
          setTotalPayableAmount(receipt_data.net_payble_amount.toFixed(2));
        }
      });
    }
  }, [enrollmentID, receiptID]);

  useEffect(() => {
    if (paymentID > 0) {
      setTotalPaidAmount(0);
      setTotalRoundOff(0);

      const payment_master = {
        formdata: {
          payment_id: paymentID,
        },
      };
      paymentService.paymentmasterDataByID(payment_master).then((res1) => {
        if (res1.data.response_status === SUCCESS_STATUS) {
          const payment_data = res1.data.response_data[0];
          console.log("object",payment_data);
          form.setFieldsValue({
            mode: "EDIT",
            payment_id: payment_data.payment_id,
            payment_date: payment_data.payment_date,
            payment_no: payment_data.payment_no,
            date_of_payment: payment_data.payment_date
              ? moment(payment_data.payment_date, DATE_FORMAT_DMY_SLASH)
              : "",
            student_account_id: payment_data.short_excess_cr_ac_id,
            member_opening_balance: payment_data.short_excess_amount,
            payment_amount: payment_data.payment_amount,
            voucher_id: payment_data.voucher_id,
            payable_amount: payment_data.total_payble_amount,
            narration: payment_data.narration,
            round_off_amount: payment_data.round_off_amount,
            round_off_account_id: payment_data.round_off_account_id,
          });
          setTotalPayableAmount(payment_data.total_payble_amount.toFixed(2));
          setTotalPaidAmount(payment_data.payment_amount.toFixed(2));
       
          setTotalRoundOff(payment_data.round_off_amount);
        }
      });

      const data = {
        formdata: {
          payment_id: paymentID,
        },
      };

      paymentService.paymentDetailsDataByID(data).then((res) => {
        if (res.data.response_status === SUCCESS_STATUS) {
          let payment_list = res.data.response_data;
          const newData = payment_list.map((details) => {
            return { ...details };
          });
          setPaymentPaidList(newData);
        }
      });
    }
  }, [paymentID]);

  // Time Slot Details
  useEffect(() => {
    if (receiptID > 0 && enrollmentID > 0) {
      const data = {
        formdata: {
          enrollment_id: enrollmentID,
        },
      };

      timeSlotService.memberTimeSlotDetails(data).then((res) => {
        if (res.data.response_status === SUCCESS_STATUS) {
          const member_time_slot_details = res.data.response_data;
          let obj = [];
          member_time_slot_details.map((e) => {
            const time_slot = {
              day_id: e.day_id,
              time_slot_id: e.time_slot,
            };
            obj.push(time_slot);
          });

          form.setFieldsValue({ day_slot: obj });
        }
      });
    }
  }, [enrollmentID, receiptID]);

  /*
  useEffect(() => {
    if (receiptID > 0 && enrollmentID > 0) {
      setIsAdmissionComponentRender(false)
      const data = {
        formdata: {
          receipt_id: receiptID,
          component_type: "ADMISSION",
        },
      };

      enrollmentService.componentDetailsAgainstReceipt(data).then((res) => {
        if (res.data.response_status === SUCCESS_STATUS) {
          const monthly_component_details = res.data.response_data;
          let obj = [];
          monthly_component_details.map((e) => {
            const x = {
              component_id: e.component_id,
              description: e.description,
              month_id: e.month_id,
              year: e.year,
              amount: e.amount,
              cr_ac_id: e.cr_ac_id,
              discount: e.discount,
              taxable_amount: e.taxable_amount,
              cgst_id: e.cgst_id,
              cgst_rate: e.cgst_rate,
              cgst_rate_text: `${commonUtility.sanitizeValue(e.cgst_rate)}%`,
              cgst_amount: e.cgst_amount,
              sgst_id: e.sgst_id,
              sgst_rate: e.sgst_rate,
              sgst_rate_text: `${commonUtility.sanitizeValue(e.sgst_rate)}%`,
              sgst_amount: e.sgst_amount,
              total_gst_amount: e.total_gst_amount,
              net_amount: e.net_amount,
            };
            obj.push(x);
          });

          form.setFieldsValue({ component_details_admission: obj });
          setIsAdmissionComponentRender(true)
        }
      });
    }
  }, [enrollmentID, receiptID]);
*/

  // Set Payment Amount
  useEffect(() => {
    console.log("paymentPaidList",paymentPaidList);
    const total_paid_amount = paymentPaidList.reduce(
      (a, v) => (a = a + parseFloat(v.amount)),
      0
    );
    const total_bank_charges = paymentPaidList.reduce(
      (a, v) => (a = a + parseFloat(v.bank_charges)),
      0
    );
    console.log("total_bank_charges",total_bank_charges);

    setTotalBankCharges(
      parseFloat(commonUtility.sanitizeValue(total_bank_charges)).toFixed(2)
    );
    setTotalPaidAmount(
      parseFloat(commonUtility.sanitizeValue(total_paid_amount)).toFixed(2)
    );

    form.setFieldsValue({
      payment_amount: total_paid_amount.toFixed(2),
      total_bank_charges: total_bank_charges,
    });
  }, [paymentPaidList]);

  const handleCancel = () => {
    setOpenModal(false);
  };

  const resetFormFields = () => {
    form.resetFields();
    form.setFieldsValue({
      mode: "ADD",
      enrollment_id: 0,
      member_id: 0,
      programme_id: 0,
      group_id: "",
      voucher_id: 0,
      date_of_join: null,
      enrollment_start_date: null,
      enrollment_end_date: null,
      dr_ac_id: "",
      student_account_id: MEMBER_ACCOUNT_ID,
      member_opening_balance: 0,
      receipt_id: 0,
      receipt_no: "",
      receipt_date: null,
      is_payment_done: "N",
      no_of_months: 0,
      entry_from: "A",
      is_gst_bill: "Y",
      round_off_amount: 0,
      round_off_account_id: ROUND_OFF_ACCOUNT_ID,
      total_bank_charges: 0,
      bank_charges_account_id: BANK_CHARGES_ACCOUNT_ID,
      day_slot: [],
      component_details_admission: [],
      component_details_monthly: [],
      component_details_others: [],
      payment_data: [],
    });
  };

  function changeLocation(placeToGo) {
    navigate(placeToGo, { replace: true });
    window.location.reload();
  }

  // resetFormField

  return (
    <div className="form-input-style">
      <Row
        className="login-first-step-row"
        style={{ background: "transparent" }}
      >
        <Col
          className="form-format-type1 enrollment-form jcp-enrollment"
          xs={24}
          xl={24}
        >
          <Form
            form={form}
            layout="vertical"
            onFinish={onHPenrollmentSave}
            autoComplete="off"
            //initialValues={defaultValues}
            initialValues={defaultFormValues}
            onFieldsChange={(event) => onFormCalculation()}
            // onValuesChange={(event) => onFormCalculation()}
            onKeyUp={onFormCalculation}
            onBlur={onFormCalculation}
          >
            <Collapse
              bordered={false}
              defaultActiveKey={[
                "programme_jcp",
                "schedule_jcp",
                "receipt_jcp",
              ]}
              onChange={onChangeCollapse}
              expandIcon={({ isActive }) => (
                <CaretRightOutlined rotate={isActive ? 90 : 0} />
              )}
            >
              <Panel
                header={
                  <>
                    <h4>Programme</h4>
                  </>
                }
                key="programme_jcp"
                className="mainPanel"
              >
                <Row gutter={20}>
                  <Col xs={24} xl={12}>
                    <Row gutter={20}>
                      <Col
                        className="gutter-row"
                        xs={6}
                        xl={6}
                        style={{ marginBottom: 3 }}
                      >
                        <Form.Item name="enrolled_from" label="Fresh/Promoted">
                          <Radio.Group
                            defaultValue="FRESH"
                            buttonStyle="solid"
                            name="enrolled_from"
                            onChange={(e) => onChangeFreshPromoted(e)}
                            disabled={
                              form.getFieldValue("mode") == EDIT_MODE
                                ? true
                                : false
                            }
                          >
                            <Radio.Button value="FRESH">Fresh</Radio.Button>
                            <Radio.Button value="PROMOTED">
                              Promoted
                            </Radio.Button>
                          </Radio.Group>
                        </Form.Item>
                      </Col>
                      <Col className="gutter-row" xs={18} xl={18}>
                        <Form.Item
                          name="programme_id"
                          label="Programme"
                          rules={[
                            {
                              required: true,
                              message: "Select Programme",
                            },
                          ]}
                        >
                          <Select
                            showSearch
                            placeholder="Search to Select"
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                              //option.children.includes(input)
                              option.children
                                .toLowerCase()
                                .includes(input.toLowerCase())
                            }
                            // filterSort={(optionA, optionB) =>
                            //   optionA.children
                            //     .toLowerCase()
                            //     .localeCompare(optionB.children.toLowerCase())
                            // }
                            onSelect={(value, event) =>
                              onSelectProgramme(value, event)
                            }
                            disabled={
                              form.getFieldValue("mode") == EDIT_MODE
                                ? true
                                : false
                            }
                          >
                            <Option key={0} value={0}>
                              Select
                            </Option>
                            {programeList.length > 0
                              ? programeList.map((programe) => (
                                  <Option
                                    key={programe.programme_id}
                                    value={programe.programme_id}
                                  >
                                    {`${programe.programme_name}`}
                                  </Option>
                                ))
                              : ""}
                          </Select>
                        </Form.Item>
                      </Col>

                      <Col className="gutter-row" xs={24} xl={24}>
                        <Form.Item
                          name="member_search"
                          label="Search (Name | Mobile no | Father Name)"
                          rules={[
                            {
                              required: true,
                              message: "Select Member / Student",
                            },
                          ]}
                        >
                          <Select
                            showSearch
                            placeholder="Search to Select"
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                              //option.children.includes(input)
                              option.children
                                .toLowerCase()
                                .includes(input.toLowerCase())
                            }
                            filterSort={(optionA, optionB) =>
                              optionA.children
                                .toLowerCase()
                                .localeCompare(optionB.children.toLowerCase())
                            }
                            onSelect={(value, event) =>
                              onSelectMember(value, event)
                            }
                            disabled={
                              form.getFieldValue("mode") == EDIT_MODE
                                ? true
                                : false
                            }
                          >
                            {memberList.length > 0
                              ? memberList.map((member_list) => (
                                  <Option
                                    key={member_list.member_id}
                                    value={member_list.member_id}
                                    enrollmentid={member_list.enrollment_id}
                                  >
                                    {`${member_list.member_fname} ${
                                      member_list.member_lname
                                    } | ${member_list.primary_mobile}  ${
                                      member_list.father_name != null
                                        ? member_list.father_name
                                        : ""
                                    }`}
                                  </Option>
                                ))
                              : ""}
                          </Select>
                        </Form.Item>
                        <Form.Item name="enrollment_id" hidden={true}>
                          <Input type="text" />
                        </Form.Item>
                        <Form.Item name="old_enrollment_id" hidden={true}>
                          <Input type="text" />
                        </Form.Item>
                        <Form.Item name="mode" hidden={true}>
                          <Input type="text" />
                        </Form.Item>
                        <Form.Item name="member_id" hidden={true}>
                          <Input type="text" />
                        </Form.Item>
                        {/* <Form.Item name="programme_id" hidden={true}>
                          <Input type="text" />
                        </Form.Item> */}
                        <Form.Item name="voucher_id" hidden={true}>
                          <Input type="text" />
                        </Form.Item>
                        <Form.Item name="entry_from" hidden={true}>
                          <Input type="text" />
                        </Form.Item>
                        <Form.Item name="is_gst_bill" hidden={true}>
                          <Input type="text" />
                        </Form.Item>
                        <Form.Item name="student_account_id" hidden={true}>
                          <Input type="text" />
                        </Form.Item>
                        <Form.Item name="payment_id" hidden={true}>
                          <Input type="text" />
                        </Form.Item>
                        <Form.Item name="receipt_id" hidden={true}>
                          <Input type="text" />
                        </Form.Item>
                        <Form.Item
                          label="Payable Amt."
                          name="payable_amount"
                          hidden={true}
                        >
                          <Input type="text" />
                        </Form.Item>
                        <Form.Item
                          label="Payment Amt."
                          name="payment_amount"
                          hidden={true}
                        >
                          <Input type="text" />
                        </Form.Item>
                        <Form.Item
                          label="Bank Charge"
                          name="total_bank_charges"
                          hidden={true}
                        >
                          <Input type="text" />
                        </Form.Item>
                        <Form.Item
                          label="Bank Charge"
                          name="bank_charges_account_id"
                          hidden={true}
                        >
                          <Input type="text" />
                        </Form.Item>
                        {/* <Form.Item name="dr_ac_id" hidden={true}>
                                            <Input type="text" />
                                        </Form.Item> */}
                      </Col>

                      <Col xs={24} xl={6} hidden={true}>
                        <Form.Item name="member_name" label="Name">
                          <Input placeholder="" readOnly={true} />
                        </Form.Item>
                      </Col>

                      <Col xs={24} xl={6} hidden={true}>
                        <Form.Item name="member_primary_mobile" label="Mobile">
                          <Input
                            placeholder=""
                            addonBefore="+91"
                            readOnly={true}
                          />
                        </Form.Item>
                      </Col>

                      <Col xs={24} xl={6} hidden={true}>
                        <Form.Item
                          name="member_father_name"
                          label="Father Name"
                        >
                          <Input placeholder="" readOnly={true} />
                        </Form.Item>
                      </Col>
                      <Col className="gutter-row" xs={24} xl={6} hidden={true}>
                        <Form.Item name="date_of_birth" label="DOB">
                          <Input placeholder="" readOnly={true} />
                        </Form.Item>
                      </Col>
                      <Form.Item name="round_off_amount" hidden={true}>
                        <Input type="text" />
                      </Form.Item>
                      <Form.Item name="round_off_account_id" hidden={true}>
                        <Input type="text" />
                      </Form.Item>

                      <Col className="gutter-row" xs={24} xl={12}>
                        <Form.Item
                          name="join_date"
                          label="Date of joining"
                          rules={[
                            {
                              required: true,
                              message: "Date of joining is required",
                            },
                          ]}
                        >
                          <DatePicker
                            format={DATE_FORMAT_DMY_SLASH}
                            onChange={onDateOfJoinChange}
                            style={{ width: "100%" }}
                            inputReadOnly={true}
                          />
                        </Form.Item>
                        <Form.Item name="date_of_join" hidden={true}>
                          <Input type="text" />
                        </Form.Item>
                      </Col>

                      <Col xs={24} xl={6} hidden={true}>
                        <Form.Item
                          name="enrollment_start_date"
                          label="Programme Valid From"
                        >
                          <Input placeholder="" readOnly={true} />
                        </Form.Item>
                      </Col>

                      <Col xs={24} xl={6} hidden={true}>
                        <Form.Item
                          name="enrollment_end_date"
                          label="Programme Valid To"
                        >
                          <Input placeholder="" readOnly={true} />
                        </Form.Item>
                      </Col>

                      <Col xs={24} xl={12} hidden={true}>
                        <Form.Item
                          name="group_id"
                          label="Programme Group (Shift)"
                          rules={[
                            {
                              required: false,
                              message: "Group is required",
                            },
                          ]}
                        >
                          <Select
                            className="text-left"
                            onSelect={(value, event) =>
                              onSelectProgrammeGroup(value, event)
                            }
                          >
                            <Option value="">Select</Option>
                            {programmeGroupList.length > 0
                              ? programmeGroupList.map(
                                  (programme_group_list) => (
                                    <Option
                                      key={
                                        programme_group_list.programme_group_id
                                      }
                                      value={
                                        programme_group_list.programme_group_id
                                      }
                                    >
                                      {programme_group_list.programme_group}
                                    </Option>
                                  )
                                )
                              : ""}
                          </Select>
                        </Form.Item>
                      </Col>

                      <Col className="gutter-row" xs={24} xl={12}>
                        <Form.Item
                          name="last_paid_month_picker"
                          label="Payment Upto (Monthly)"
                        >
                          <DatePicker
                            // format={DATE_FORMAT_DMY_SLASH}
                            format="MM-YYYY"
                            onChange={onPaymentUptoChange}
                            style={{ width: "100%" }}
                            inputReadOnly={true}
                            picker="month"
                          />
                        </Form.Item>
                        <Form.Item name="last_paid_month" hidden={true}>
                          <Input type="text" />
                        </Form.Item>
                      </Col>
                    </Row>
                  </Col>{" "}
                  {/** end of column */}
                  <Col xs={24} xl={12}>
                    <Row gutter={20}>
                      <Col xs={24} xl={24}>
                        <StudentCardInfo
                          memberDisplayInfo={memberDisplayInfo}
                          memberDisplayOtherInfo={memberDisplayOtherInfo}
                        />
                      </Col>
                    </Row>
                  </Col>
                  <Col xs={24} xl={12}>
                    {isAlreadyMemberEnrolled ? (
                      <>
                        <Form.Item name="" label=" ">
                          <Alert
                            message={alreadyMemberEnrolledMessage}
                            type="error"
                          />
                        </Form.Item>
                      </>
                    ) : (
                      ""
                    )}
                  </Col>
                </Row>
              </Panel>

              {
                /**
                 * (form.getFieldValue("mode") == "EDIT" && timeSlotList.length > 0) || form.getFieldValue("mode") == "ADD"
                 */
                form.getFieldValue("mode") == "EDIT" ||
                form.getFieldValue("mode") == "ADD" ? (
                  <>
                    <Panel
                      header={
                        <>
                          <h4>Schedule</h4>
                        </>
                      }
                      key="schedule_jcp"
                      className="mainPanel"
                    >
                      {/* <TimeSlotEnrollment mode={form.getFieldValue("mode")} timeSlotListData={timeSlotList} key={commonUtility.randomID()} /> */}
                      <TimeSlotEnrollment
                        mode={form.getFieldValue("mode")}
                        timeSlotListData={timeSlotList}
                        key={commonUtility.randomID()}
                        isDayRequired={true}
                        isDayTimeRequired={false}
                        module={HIGH_PERFORMANCE_TAG}
                        form={form}
                      />
                    </Panel>
                  </>
                ) : (
                  ""
                )
              }

              <Panel
                header={
                  <>
                    <h4>Receipt</h4>
                  </>
                }
                key="receipt_jcp"
                className="mainPanel"
              >
                {/* <Row gutter={20}>
                  <Col xs={24} xl={6}>
                    <Form.Item name="receipt_no" label="Receipt Number">
                      <Input type="text" readOnly={true} />
                    </Form.Item>
                  </Col>

                  <Col xs={24} xl={6}>
                    <Form.Item name="receipt_date_input" label="Receipt Date">
                      <DatePicker
                        format={DATE_FORMAT_DMY_SLASH}
                        onChange={onDateOfReceiptChange}
                        style={{ width: "100%" }}
                        inputReadOnly={true}
                        defaultValue={moment()}
                      />
                    </Form.Item>
                    <Form.Item name="receipt_date" hidden={true}>
                      <Input type="text" />
                    </Form.Item>
                    <Form.Item name="receipt_id" hidden={true}>
                      <Input type="text" />
                    </Form.Item>
                    
                  </Col>
                </Row> */}
                <Collapse
                  defaultActiveKey={[
                    "admission_component_panel",
                    "monthly_component_panel",
                    "other_component_panel",
                    "member_payment_panel",
                  ]}
                  ghost
                >
                  {commonUtility.sanitizeValue(programmeID) > 0 ? (
                    <>
                      <Panel
                        header="Admission (will appear if programme group  / shift selected)"
                        key="admission_component_panel"
                        className="admission-component-panel component-panel innerPanel"
                      >
                        <EnrollmentComponent
                          enrollmentForm={form}
                          detailInputKey="component_details_admission"
                          onFormCalculation={onFormCalculation}
                          admissionComponents={progCommercialCompAdmissionList}
                          //componentFor="ADMISSION"
                        />
                      </Panel>
                    </>
                  ) : (
                    <></>
                  )}

                  <Panel
                    header="Monthly (will appear if programme group and date of joining selected)"
                    key="monthly_component_panel"
                    className="monthly-component-panel component-panel innerPanel"
                    style={{ display: "none" }}
                  >
                    <Row gutter={20}>
                      <Col>
                        <p>Monthly Slots for </p>
                      </Col>
                      <Col>
                        <Form.Item name="no_of_months" label="">
                          <Input
                            placeholder="Enter month value"
                            onChange={(event, value) => {
                              onChangeMonthlyMonth(event, value);
                            }}
                          />
                        </Form.Item>
                      </Col>
                      <Col>
                        <p>months</p>
                      </Col>
                    </Row>
                    <EnrollmentComponent
                      enrollmentForm={form}
                      detailInputKey="component_details_monthly"
                      onFormCalculation={onFormCalculation}
                      //componentFor="MONTHLY"
                    />
                  </Panel>

                  {/* <Panel header="Other Items" key="other_component_panel" className="other-component-panel component-panel innerPanel">
                    <EnrollmentComponent
                                            enrollmentForm={form}
                                            detailInputKey="component_details_others"
                                        />
                    <OtherItems
                      enrollmentForm={form}
                      detailInputKey="component_details_others"
                      initialValuesOtherItemList={progCommercialCompOtherListInitialValue}
                      onFormCalculation={onFormCalculation}
                      isGST="Y"
                    />
                    <TestFormItem />
                  </Panel> */}

                  <Panel
                    header="Receipt"
                    key="member_payment_panel"
                    className="member-payment component-panel innerPanel"
                  >
                    {/**
                     * Payments Module
                     */}

                    <PaymentComponent
                      enrollmentForm={form}
                      detailInputKey="component_payment"
                      addPaymentMode={addPaymentMode}
                      paymentPaidList={paymentPaidList}
                      removePayment={removePayment}
                      remainingAmount={remainingAmount}
                      isPaymentModeDisabled={isPaymentModeDisabled}
                      admissionComponents={progCommercialCompAdmissionList}
                    />
                  </Panel>
                </Collapse>

                <div className="totalDetails">
                  <Row gutter={20}>
                    <Col xs={24} xl={20} align="right">
                      <Text>Total Amount : </Text>
                    </Col>
                    <Col xs={24} xl={4} align="right">
                      <Text strong>{totalAmount} </Text>
                    </Col>
                  </Row>
                  <Row gutter={20}>
                    <Col xs={24} xl={20} align="right">
                      <Text>Total Discount : </Text>
                    </Col>
                    <Col xs={24} xl={4} align="right">
                      <Text strong>{totalDiscountAmount} </Text>
                    </Col>
                  </Row>

                  <Row gutter={20}>
                    <Col xs={24} xl={20} align="right">
                      <Text>Total Taxable : </Text>
                    </Col>
                    <Col xs={24} xl={4} align="right">
                      <Text strong>{totalTaxableAmount} </Text>
                    </Col>
                  </Row>

                  <Row gutter={20}>
                    <Col xs={24} xl={20} align="right">
                      <Text>Total CGST : </Text>
                    </Col>
                    <Col xs={24} xl={4} align="right">
                      <Text strong>{totalCGSTAmount} </Text>
                    </Col>
                  </Row>

                  <Row gutter={20}>
                    <Col xs={24} xl={20} align="right">
                      <Text>Total SGST : </Text>
                    </Col>
                    <Col xs={24} xl={4} align="right">
                      <Text strong>{totalSGSTAmount} </Text>
                    </Col>
                  </Row>

                  <Row gutter={20}>
                    <Col xs={24} xl={20} align="right">
                      <Text>Total Net Amount : </Text>
                    </Col>
                    <Col xs={24} xl={4} align="right">
                      <Text strong>{totalNetAmount} </Text>
                    </Col>
                  </Row>

                  {/* <Row gutter={20}>
                    <Col xs={24} xl={20} align="right">
                      <Text italic>Bank Charges :  </Text>
                    </Col>
                    <Col xs={24} xl={4} align="right">
                      <Text strong>{totalBankCharges}</Text>
                    </Col>
                  </Row> */}

                  <Row gutter={20}>
                    <Col xs={24} xl={20} align="right">
                      <Text>Round Off : </Text>
                    </Col>
                    <Col xs={24} xl={4} align="right">
                      <Text strong>{totalRoundOff} </Text>
                    </Col>
                  </Row>

                  {/* ------Previous Code----------
                  <Row gutter={20}>
                    <Col xs={24} xl={20} align="right">
                      <Text italic style={{ fontSize: "18px", color: "#fb3b3b" }}>Total Payable = Amount to pay + Bank Charges(if any)  :  </Text>
                    </Col>
                    <Col xs={24} xl={4} align="right">
                      <Text strong style={{ fontSize: "18px", color: "#fb3b3b" }}>{totalPayableAmount} + {totalBankCharges}</Text>
                    </Col>
                  </Row> */}

                  {/* New Changes on 02/04/24 =================Start Here*/}

                  <Row gutter={20}>
                    <Col xs={24} xl={20} align="right">
                      <Text
                        italic
                        style={{ fontSize: "18px", color: "#fb3b3b" }}
                      >
                        Amount to pay :{" "}
                      </Text>
                    </Col>
                    <Col xs={24} xl={4} align="right">
                      <Text
                        strong
                        style={{ fontSize: "18px", color: "#fb3b3b" }}
                      >
                        {totalPayableAmount}
                      </Text>
                    </Col>
                  </Row>
                  <Row gutter={20}>
                    <Col xs={24} xl={20} align="right">
                      <Text
                        italic
                        style={{ fontSize: "18px", color: "#fb3b3b" }}
                      >
                        Bank Charges(if any) :{" "}
                      </Text>
                    </Col>
                    <Col xs={24} xl={4} align="right">
                      <Text
                        strong
                        style={{ fontSize: "18px", color: "#fb3b3b" }}
                      >
                        {totalBankCharges}
                      </Text>
                    </Col>
                  </Row>
                  <Row gutter={20}>
                    <Col xs={24} xl={20} align="right">
                      <Text
                        italic
                        style={{ fontSize: "18px", color: "#fb3b3b" }}
                      >
                        Total Payable :{" "}
                      </Text>
                    </Col>
                    <Col xs={24} xl={4} align="right">
                      <Text
                        strong
                        style={{ fontSize: "18px", color: "#fb3b3b" }}
                      >
                        {(
                         
                          Number(totalPayableAmount) + Number(totalBankCharges)
                        ).toFixed(2)}
                      </Text>
                    </Col>
                  </Row>
                  {/* New Changes on 02/04/24 =================== Ends Here*/}

                  <Row gutter={20}>
                    <Col xs={24} xl={20} align="right">
                      <Text
                        italic
                        style={{ fontSize: "18px", color: "#23910c" }}
                      >
                        Total Paid :{" "}
                      </Text>
                    </Col>
                    <Col xs={24} xl={4} align="right">
                      <Text style={{ fontSize: "18px", color: "#23910c" }}>
                        {totalPaidAmount}{" "}
                      </Text>
                    </Col>
                  </Row>

                  <Row gutter={20}>
                    <Col xs={24} xl={20} align="right">
                      <Text>
                        {" "}
                        {remainingAmount < 0 ? "Excess" : "Short"} Amount :{" "}
                      </Text>
                    </Col>
                    <Col xs={24} xl={4} align="right">
                      <Text strong>
                        {Math.abs(remainingAmount).toFixed(2)}{" "}
                      </Text>
                    </Col>
                  </Row>
                </div>

                <Row justify="end">
                  <Col>
                    <Form.Item>
                      {/* <ModalWithMessageAndAction /> */}

                      {/* <Button
                            htmlType="submit"
                            shape="round"
                            disabled={isAlreadyMemberEnrolled}
                            className="custom-button-green"
                          >
                            Save <RightOutlined />
                          </Button> */}

                      {isSaveLoaderEnable ? (
                        <Spin />
                      ) : (
                        <>
                          <Button
                            htmlType="submit"
                            shape="round"
                            disabled={isAlreadyMemberEnrolled}
                            className="custom-button-green"
                          >
                            Save <RightOutlined />
                          </Button>
                        </>
                      )}
                    </Form.Item>
                  </Col>
                </Row>
              </Panel>
            </Collapse>
          </Form>
        </Col>
      </Row>

      {/* <Button type="primary" onClick={props.showModal}>
        Vertically centered modal dialog
      </Button> */}

      {/* <ModalWithMessageAndAction responseModalTitle={responseModalTitle} openModal={openModal} handleCancel={handleCancel} listLink={'high-performance/receipt-list-hp'} addmoreLink={'high-performance'} responseModalMessage={responseModalMessage} /> */}

      {responseModal.isOpenModal ? (
        <>
          <ModalWithMessageAndAction responseModal={responseModal} />
        </>
      ) : (
        <></>
      )}
    </div>
  );
};
export default HpEnrollmentEntry;
